<div class="report-container">
    <tr-viewer #viewer1
        [containerStyle]="viewerContainerStyle"
        [serviceUrl]="serviceUrl"
        [reportSource]="{
            report: reportName,
            parameters: reportParams
        }"
        [viewMode]="'INTERACTIVE'"
        [scaleMode]="'SPECIFIC'"
        [scale]="1.0"
        [ready]="ready"
        [renderingEnd]="onReportRendered"
        [error]="onReportError"
        [viewerToolTipOpening]="viewerToolTipOpening"
        [enableAccessibility]="false"
        [authenticationToken]="authToken"
        [parameters]="parameterEditorSettings"
        [parametersAreaVisible]="parametersAreaVisible"
    >
    </tr-viewer>

    <!-- <button (click)="viewer1.refreshReport()">Refresh</button>
    <button (click)="viewer1.commands.print.exec()">Print</button> -->
</div>



// WEBPACK FOOTER //
// ./src/app/core/components/report-viewer/report-viewer.component.html